import { gql } from 'graphql-request';

import { ArticleTemplateQuery } from '@orgnc/core/lib/themes/queries';
import mediaFragment from '@orgnc/core/lib/wordpress/api/fragments/mediaFragment';
import {
  IPostExtraFieldsQuery,
  IPostExtraFieldsQueryVariables,
} from '@orgnc/core/generated/graphql-operations';

const query = gql`
  query PostExtraFieldsQuery($dbId: ID!) {
    post(id: $dbId, idType: DATABASE_ID) {
      databaseId
      aimFeaturedImage {
        hideableFeaturedImage {
          node {
            ...MediaFragment
          }
        }
      }
      contactInformation {
        faxNumber
        email
        telephoneNumber
        websiteUrl
        informationRequestUrl
      }
    }
    flexpressCMSSettings {
      generalOptions {
        aimPosts {
          enableHideableFeaturedImage
        }
      }
    }
  }
  ${mediaFragment}
`;

const postExtraFieldsQuery: ArticleTemplateQuery<
  IPostExtraFieldsQuery,
  IPostExtraFieldsQueryVariables
> = {
  name: 'postExtraFieldsQuery',
  query,
  queryArguments: (contentData) => {
    return {
      dbId: contentData.databaseId?.toString() || '',
    };
  },
};

export default postExtraFieldsQuery;
